module.exports = __webpack_public_path__ + "static/media/sip_resumed_illustration.e883e5cc.svg";